import 'prismjs/themes/prism.css';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';
import './src/assets/fonts/icomoon.css';
import './src/assets/css/tailwind.css';
